export default {
  organizations: [],
  organizationsMap: {},
  businessGroups: [],
  businessGroupsMap: {},
  loaded: {},
  billingInfosMap: {},
  billingInfos: [],
  pricingLevelGroupsMap: {},
  pricingLevelGroups: [],
};
